module.exports = __webpack_public_path__ + "media/images/emblems/Eschenbach_LU-bb83eda8b77f53998c3c7e9a9ee83578.png";